import { SearchIcon } from "lucide-react";
import * as React from "react";

import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

type SearchFieldProps = Omit<
  React.ComponentPropsWithRef<typeof Input>,
  "type"
> & {
  density?: "default" | "compact";
};

function SearchField({
  className,
  density = "default",
  ...props
}: SearchFieldProps) {
  return (
    <div
      className={cn("relative min-w-0 w-full", className)}
      data-slot="search-field"
    >
      <SearchIcon
        aria-hidden
        className={cn(
          "pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground",
          density === "compact" ? "size-3.5" : "size-4",
        )}
      />
      <Input
        {...props}
        className={cn(
          "border-2",
          density === "compact" ? "h-7 pl-7 text-xs" : "pl-8",
        )}
        type="search"
      />
    </div>
  );
}

export { SearchField };
